
export default (data) => ({
  title: '',
  json: data?.description?.json ?? undefined,
  video: {
    url: '/source_videos/BALENCIAGA_MAIN_1920x1080_16-9.mp4',
    contentType: 'video/mp4',
  },
})
